<template>
    <div class="event3 scrollstyle">
        <div class="event3-title">{{ $t(eventName + '_text1') }}</div>
        <p class="event3-cont">
            {{ $t(eventName + '_text2') }}
        </p>

        <div class="event3-step">
            <div v-if="isStage1Finish" class="stepFinshFrame">
                <div class="cont" :class="{'en': lang =='en'}">
                    {{ $t(eventName + '_finsh') }}
                </div>
            </div>
            <div class="event3-step-title">
            <!-- <div class="event3-step-title" @click="stage1Cont = !stage1Cont"> -->
                {{ $t(eventName + '_text3') }}
                <!-- <n-icon style="margin-left: 5px;" size="23" color="#2196F3" :component="InformationCircleOutline" /> -->
            </div>
            <div class="event3-step-subTitle">
                － {{ $t(eventName + '_text4') }}
            </div>
            <div v-if="stage1Cont" class="event3-step-subCont">{{ $t(eventName + '_text5') }}</div>
        </div>
        <div class="event3-arrow">
            <n-icon size="25" color="#333" :component="ChevronDown"/>
        </div>
        <div class="event3-step">
            <div v-if="isStage2Finish" class="stepFinshFrame">
                <div class="cont" :class="{'en': lang =='en'}">
                    {{ $t(eventName + '_finsh') }}
                </div>
            </div>
            <div style="display: flex;align-items: center;justify-content: space-between;">
                <div>
                    <div class="event3-step-title"  @click="stage2Cont = !stage2Cont">
                        {{ $t(eventName + '_text6') }}
                        <n-icon style="margin-left: 5px;" size="23" color="#2196F3" :component="InformationCircleOutline"/>
                    </div>
                    <div class="event3-step-subTitle">
                        － {{ $t(eventName + '_text7') }}
                    </div>
                </div>
                <n-button type="info" ghost v-if="!isStage2Finish" @click="exchangeCoupon">
                    {{ $t(eventName + '_btn1') }}
                </n-button>
            </div>
            <div v-if="stage2Cont" class="event3-step-subCont">{{ $t(eventName + '_text8')}}</div>
        </div>
        <div class="event3-arrow">
            <n-icon size="25" color="#333" :component="ChevronDown"/>
        </div>
        <div class="event3-step">
            <div v-if="isStage3Finish" class="stepFinshFrame">
                <div class="cont" :class="{'en': lang =='en'}">
                    {{ $t(eventName + '_finsh') }}
                </div>
            </div>
            <div class="event3-step-title" @click="stage3Cont = !stage3Cont">
                {{ $t(eventName + '_text9')}}
                <n-icon style="margin-left: 5px;" size="23" color="#2196F3" :component="InformationCircleOutline" />
            </div>
            <div class="event3-step-subTitle">－ {{ $t(eventName + '_text10')}}</div>
            <div v-if="stage3Cont" class="event3-step-subCont" v-html="$t(eventName + '_text11')"/>
        </div>

        <div class="event3-remark">
            <ul>
                <li>{{ $t(eventName + '_text12')}}</li>
                <li>{{ $t(eventName + '_text13')}}</li>
                <li v-if="$te(eventName + '_text15')">{{ $t(eventName + '_text15')}}</li>
                <li v-html="$t(eventName + '_text14')"></li>
            </ul>
        </div>
    </div>
</template>
<script>
    // import {reactive, ref, computed, watch, watchEffect} from 'vue'
    import { ref, inject, computed } from 'vue'
    import { useRoute } from 'vue-router';
    import { useStore } from "vuex"
    import { useI18n } from "vue-i18n";
    import naiveFnc from "@/utils/naiveFnc";
    import { ChevronDown, InformationCircleOutline } from '@vicons/ionicons5'
    export default {
        setup() {
            // 元件宣告
            const { t } = useI18n()
            const route = useRoute()
            const store = useStore()
            const { crtDialog } = naiveFnc();

            // 變數宣告
            const stage1Cont = ref(false)
            const stage2Cont = ref(false)
            const stage3Cont = ref(false)

            const isStage1Finish = ref(false)
            const isStage2Finish = ref(false)
            const isStage3Finish = ref(false)

            const COUPON50STEP2 = '50STEP2'
            const COUPON333STEP2 = '333STEP2'
    
            // 全螢幕的spin
            const changeSpinState = inject('changeSpinState')
            
            const events = computed(() => store.getters["coreApi/events"]);

            let lang = route.params.lang
            let eventName = ''

            if(events.value){
                events.value.forEach(x => {
                    if(x.name == 'hiteach333' || x.name == 'hiteach50') {
                        eventName = x.name
                        x.steps.forEach( y => {
                            switch (y.step){
                                case 1:
                                    if(y.done != -1) isStage1Finish.value = true
                                break
                                case 2:
                                    if(y.done != -1) isStage2Finish.value = true
                                break
                                case 3:
                                    if(y.done != -1) isStage3Finish.value = true
                                break
                            }
                        })
                    }
                })
            }
            
            //method
            async function exchangeCoupon() {
                changeSpinState() // 開啟全屏spin
                var coupon = ''
                var errStr = ""
                var couponInfo = {
                    eventId: '',
                    expire: 0,
                    voucher: '',
                    info: [],
                    eventName:''
                }

                if(eventName == 'hiteach333') {
                    coupon = COUPON333STEP2
                } else if(eventName == 'hiteach50') {
                    coupon = COUPON50STEP2
                }

                await store.dispatch('coreApi/getCoupon', coupon).then( res => {
                    if(res.error) {
                        let error = res.error.toString()
                        switch(error) {
                            case '9':
                                errStr = t('error_9')
                            break
                            case '14':
                                errStr = t('error_10')
                            break
                            case '15':
                                errStr = t('error_11')
                            break
                            case '20':
                                errStr = t('error_12')
                            break
                        }
                    } else {
                        couponInfo = res
                    }
                }).catch( e =>{
                    console.log(e)
                    errStr = t('error_3')
                }).finally(()=>{
                    changeSpinState()  // 關閉全屏spin
                })

                if(errStr != "") {
                    crtDialog(t('notice'), errStr)
                } else {
                    exchangeVoucher(couponInfo)
                }
            }

            async function exchangeVoucher(couponInfo) {
                changeSpinState() // 開啟全屏spin
                var errStr = ""

                await store.dispatch('coreApi/exchangeVoucher', couponInfo.voucher).then( res => {
                    if(res.error) {
                        let error = res.error.toString()
                        switch(error) {
                            // case '8':
                            //   errStr = '票卷已過期'
                            // break
                            // case '9':
                            //   errStr = '你已使用過該票券'
                            // break
                            // case '12':
                            //     errStr = '活動尚未開始'
                            // break
                            // case '16':
                            //     errStr = '降規格(權益折損)'
                            // break
                            default:
                            errStr = t('error_10')
                        }
                    }
                }).catch( e =>{
                    console.log(e)
                    errStr = t('error_3')
                }).finally(()=>{
                    changeSpinState()  // 關閉全屏spin
                })

                if(errStr != "") {
                    crtDialog(t('notice'), errStr)
                } else {
                    if(couponInfo.eventName !='' && couponInfo.eventName != null && typeof couponInfo.eventName != 'undefined'){
                        if(couponInfo.eventName.indexOf('hiteach333') >= 0 || couponInfo.eventName.indexOf('hiteach50') >= 0){
                            let eventTemp = couponInfo.eventName.split('-')
                            let eventName = eventTemp[0].toLocaleLowerCase()
                            let eventStep = eventTemp[1]
                            let temp = events.value.filter( y => y.name.toLocaleLowerCase() == eventName)
                            if(temp.length == 0) {
                                await store.dispatch("coreApi/setUserEvents", {name: eventName, step: 1, done: new Date().getTime()})
                            } else {
                                await store.dispatch("coreApi/updUserEvents", {name: eventName, step: Number(eventStep), done: new Date().getTime()})
                            }

                            switch (Number(eventStep)){
                                case 1:
                                    isStage1Finish.value = true
                                break
                                case 2:
                                    isStage2Finish.value = true
                                break
                                case 3:
                                    isStage3Finish.value = true
                                break
                            }

                            // 儲存現在的usersetting
                            await store.dispatch("coreApi/setUsersetting")
                        }
                    }

                    crtDialog("", t('discovery_9'))
                }
            }
            
            return {
                lang,
                ChevronDown,
                InformationCircleOutline,
                stage1Cont,
                stage2Cont,
                stage3Cont,
                isStage1Finish,
                isStage2Finish,
                isStage3Finish,
                eventName,
                exchangeCoupon
            }
        },
    }
</script>
<style lang="less" scoped>
.event3 {
    white-space: pre-line;
    position: relative;
    &-title{
        text-align: center;
        font-size: 22px;
        font-weight: bold;
        font-family: monospace;
        color: #03c5fb;
        line-height: 1.2;
    }
    &-cont{
        font-size: 13px;
        color: #616161;
        text-indent: 10px;
        margin-left: 3px;
        margin-right: 3px;
    }
    &-step{
        border: 2px solid #333;
        border-radius: 6px;
        padding: 9px 12px;
        margin-bottom: 7px;
        position: relative;
        &-title{
            font-size: 15px;
            display: flex;
            align-items: center;
        }
        &-subTitle{
            font-size: 13px;
            font-weight: 300;
            display: flex;
            align-items: center;
        }
        &-subCont{
            font-size: 13px;
            font-weight: 300;
            border-top: 1px dashed #333;
            margin-top: 15px;
            padding-top: 6px;
        }
        .stepFinshFrame{
            border: 4px solid rgb(230, 74, 25);
            padding: 7px;
            border-radius: 50%;
            color: rgb(230, 74, 25);
            position: absolute;
            right: 0px;
            // top: calc(50% - 42px);
            top: -10px;
            width: 60px;
            height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;
            .cont{
                display: flex;
                font-size: 20px;
                line-height: 1;
                width: 50px;
                height: 50px;
                align-items: center;
                justify-content: center;
                transform: rotate(-20deg);
                border: 1px solid rgb(230, 74, 25);
                padding: 7px;
                border-radius: 50%;
                color: rgb(230, 74, 25);
                position: absolute;
                text-align: center;
                &.en{
                    font-size: 17px;
                }
            }
        }
    }
    &-arrow{
        display: flex;
        justify-content: center;
        margin-top: 5px;
    }
    &-remark{
        margin-top: 20px;
        ul{
            font-size: 12px;
            padding-left: 20px;
        }
    }
}
</style>